export enum UserRole {
  ADMIN = 'ADMIN',
  READ_ONLY = 'READ_ONLY',
  WHITE_LABEL = 'WHITE_LABEL',
}
